import { render } from "./lightBoxPhotos.vue?vue&type=template&id=11f5858b"
import script from "./lightBoxPhotos.vue?vue&type=script&lang=js"
export * from "./lightBoxPhotos.vue?vue&type=script&lang=js"

import "./lightBoxPhotos.vue?vue&type=style&index=0&id=11f5858b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__